
import {Component, Vue} from "vue-property-decorator";
import api from '@/api'

@Component({
  name: 'ReceiversSetting'
})
export default class ReceiversSetting extends Vue {


  email: string = ''

  allEmails: string[] = []
  saving = false;
  loading = true;

  created() {
    api.configuration.getSplitOrderBillReceivers().then((value) => {
      this.allEmails = value ? value.split(',') : []
      this.loading = false;
    })
  }

  addEmail() {
    if (!this.email) {
      return;
    }

    if (this.allEmails.length >= 10) {
      this.$message.error('最多支持10个接收人')
      return;
    }

    if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)) {
      if (this.allEmails.some(email => email === this.email)) {
        this.$message.error('该邮件已添加，不可重复添加')
      } else {
        this.allEmails.push(this.email);
        this.email = ''
      }

    } else {
      this.$message.error('您输入的邮箱格式不正确')
    }
  }

  remove(index: number) {
    this.allEmails.splice(index, 1);
  }

  update() {
    this.saving = true;
    api.configuration.updateSplitOrderBillReceivers({body: {receivers: this.allEmails}}).then(() => {
      this.saving = false;
      this.$message.success('邮件接收人更新成功')
    }).catch(() => {
      this.saving = false;
    })
  }


}
